import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MultiSelect } from '@flightstats/component-lib';

class GenericMultiSelect extends Component {
  static propTypes = {
    action: PropTypes.func,
    dispatch: PropTypes.func,
    identifier: PropTypes.string,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    value: PropTypes.array,
  }

  getOptions = () => {
    if (this.props && this.props.options) {
      const {
        options,
      } = this.props;
      return options;
    }
    return [{ label: '', value: '' }];
  }

  handleSelectChange = (value) => {
    const { dispatch, action, identifier } = this.props;

    return dispatch(action({ value, identifier }));
  }

  render() {
    const { placeholder, value } = this.props;

    return (
      <MultiSelect
        value={value}
        placeholder={placeholder}
        results={this.getOptions()}
        handleMenuSelection={this.handleSelectChange}
      />
    );
  }
}

export default GenericMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lib/GenericMultiSelect.js